import { PBTEngagementModel } from '../../Interfaces/IPBTCase';
import type { IPBTCase } from '../../Interfaces/IPBTCase';

export function isHrcLedBypass(pbtCase: IPBTCase): boolean {
  return pbtCase.engModel === PBTEngagementModel.HRCLed;
}

export function getManagerActionActor(pbtCase: IPBTCase): { label: string; value: string } {
  if (isHrcLedBypass(pbtCase)) {
    return { label: 'Assigned To (HRC)', value: pbtCase.hrc };
  }
  return { label: 'Assigned Manager', value: pbtCase.manager };
}
